var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ProgressBar, Text } from "./";
import React from 'react';
import { applyCyAttribute } from "../utils";
var isPositiveNumber = function (number) { return number > 0; };
var isStepIndex = function (index, stepsNumber) {
    return index >= 0 && index <= stepsNumber;
};
var getProgressPercentage = function (index, stepsNumber) {
    return (index / stepsNumber) * 100;
};
var StepProgressBar = function (_a) {
    var step = _a.step, stepsNumber = _a.stepsNumber, label = _a.label, className = _a.className;
    if (!isPositiveNumber(stepsNumber)) {
        throw new Error('Number of steps has to be the positive number.');
    }
    if (!isStepIndex(step, stepsNumber)) {
        throw new Error("Current step index has to be withing range of 0 and ".concat(stepsNumber, ". Current step: ").concat(step, "."));
    }
    var progress = getProgressPercentage(step, stepsNumber);
    return (React.createElement(React.Fragment, null,
        label ? (React.createElement(Text, __assign({ "data-component": "StepProgressBar-Text", fontWeight: "bold", fontSize: "tiny", mb: 1 }, applyCyAttribute('dataStepProgressBarText')), label.replace('%(percentage)', Math.floor(progress).toString()))) : null,
        React.createElement(ProgressBar, __assign({ "data-component": "StepProgressBar", progress: progress, withShadow: true }, applyCyAttribute(label ? 'dataStepProgressBar' : 'stepProgressBar')))));
};
export default StepProgressBar;
//# sourceMappingURL=StepProgressBar.js.map